<ik-modal (OnClose)="dialogRef.close()">
    <ng-container header>
        {{'Adresses de facturation' | transloco}}
    </ng-container>
    <ng-container main>
        <div class="description">
            {{'Selectionner l\'adresse de facturation par defaut de votre organisation.' | transloco}}
        </div>
        <div class="addresses">
            <div class="address"
                 *ngFor="let address of data.billingAddresses">
                <div class="address-left">
                    <div class="address-left__organization">
                        {{address.organization_name}}
                    </div>
                    <div class="address-left__street">
                        {{address.street}}
                    </div>
                    <div class="address-left__code">
                        {{address.zip_code}} {{address.zip_city}} {{address.country}}
                    </div>
                </div>
                <div class="address-right">
                    <mat-checkbox class="checkbox-rounded"
                                  [checked]="address.id === selectedAddress.id"
                                  (change)="onSelectAddress($event, address)"
                                  color="primary">
                    </mat-checkbox>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container footer>
        <button mat-flat-button
                mat-dialog-close
                [attr.aria-label]="'Annuler' | transloco"
                color="accent">
            {{ 'Annuler' | transloco }}
        </button>

        <button mat-flat-button
                color="primary"
                (click)="save()">
            {{ 'Enregistrer' | transloco }}
        </button>
    </ng-container>
</ik-modal>